import { RouteObject } from "react-router-dom"
import Root from "./Root"
import NotFound from "./NotFound"
import { BasicLayout } from "./layouts"
import homeRoute from "./home"
import projectsRoute from "./projects"
import authsRoute from "./auths"
import schedulesRoute from "./schedules"
import {
  // worktimeLeadRoute,
  worktimeDailyRoute,
} from "./worktime"
import ithRoute from "./ithClient"
import { isDev } from "../config/common"

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Root />,
    children: [
      isDev
        ? authsRoute
        : {},
      {
        path: "/",
        element: <BasicLayout />,
        children: [
          homeRoute,
          projectsRoute,
          schedulesRoute,
          // worktimeRoute,
          // worktimeLeadRoute,
          worktimeDailyRoute,
        ],
      },
      ithRoute,
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
]

export default routes
